import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging";
import axios from "axios";

const firebaseConfig = {
  apiKey: "AIzaSyDkr5SQtFA6f-9GiOnCVbmzQ486EJQIJzQ",
  authDomain: "fibernet-tv.firebaseapp.com",
  projectId: "fibernet-tv",
  storageBucket: "fibernet-tv.firebasestorage.app",
  messagingSenderId: "864669397872",
  appId: "1:864669397872:web:7b4fa62710a1396a2015b5",
};

const VAPID_KEY = "BJlt2G1lg20bntobJjx9SDpjSt6fB4UtEnz411GiwfxAFfnczulY0tKtf0-jxA_0cDsBCIgaILNuP7vEDOapqqw";
const BACKEND = process.env.REACT_APP_BACKEND_URL;

export async function initWebPush() {
  try {
    if (!(await isSupported())) return { ok: false, reason: "unsupported" };
    if (Notification.permission === "denied") return { ok: false, reason: "denied" };
    if (Notification.permission === "default") {
      const perm = await Notification.requestPermission();
      if (perm !== "granted") return { ok: false, reason: "dismissed" };
    }
    const app = initializeApp(firebaseConfig);
    const messaging = getMessaging(app);
    const sw = await navigator.serviceWorker.register("/firebase-messaging-sw.js");
    const token = await getToken(messaging, { vapidKey: VAPID_KEY, serviceWorkerRegistration: sw });
    if (!token) return { ok: false, reason: "no-token" };
    await axios.post(`${BACKEND}/api/push/register`, { token, platform: "web" });
    onMessage(messaging, (payload) => {
      const n = payload.notification || {};
      const data = payload.data || {};
      if (Notification.permission === "granted") {
        const notif = new Notification(n.title || "Fibernet TV", { body: n.body || "", icon: "/logo192.png" });
        notif.onclick = () => {
          if (data.campaign_id) {
            axios.post(`${BACKEND}/api/push/open`, { campaign_id: data.campaign_id, platform: "web" }).catch(() => {});
          }
          window.focus();
          if (data.link) window.location.href = data.link;
          notif.close();
        };
      }
    });
    return { ok: true, token };
  } catch (e) {
    console.warn("Web push init failed:", e?.message);
    return { ok: false, reason: e?.message };
  }
}
